import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddDesignationApi } from "./designationAction";
import { GetDivisionApi } from "../division/divisionAction";
import { GetDepartmentByDivisionIdApi } from "../department/departmentAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Select from 'react-select';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddDesignation = (props) => {
    const [divisionId, setDivisionId] = useState(0);
    const [divisionName, setDivisionName] = useState(0);
    const [designationName, setDesignationName] = useState("");
    const [designationDescription, setDesignationDescription] = useState();
    const [departmentId, setDepartmentId] = useState(0);
    const [departmentName, setDepartmentName] = useState(0);


    function uploadDesignation() {
        props.AddDesignationApi({
            designation: _.upperCase(designationName),
            description: _.upperCase(designationDescription),
            divisionDetails: {
                _id: divisionId,
                name: divisionName,
            },
            departmentDetails: {
                _id: departmentId,
                department: departmentName,
            }
        },
            showSuccessAlert,
            showErrorAlert
        );
        clearStates()
    }
    const clearStates = () => {
        setDivisionId(0);
        setDesignationName();
        setDesignationDescription();
        setDepartmentId(0);
    }

    const getDivisionList = _.isArray(props.divisionList) && !_.isEmpty(props.divisionList)
        ? props.divisionList.map((x) => ({ value: x._id, label: x.name }))
        : [];
    const handleChangeDivision = (selectedOption) => {
        setDivisionId(selectedOption.value);
        setDivisionName(selectedOption.label);
        props.GetDepartmentByDivisionIdApi(selectedOption.value);
    }
    const getDepartmentNameList = (!_.isEmpty(props.departmentList)) ? (props.departmentList.map((x) => {
        let data = { value: x._id, label: x.department };
        return data
    })) : [];
    const handleChangeDepartment = (selectedOption) => {
        setDepartmentId(selectedOption.value);
        setDepartmentName(selectedOption.label);
    };

    useEffect(() => {
        props.setHeading("Designation Add")
        props.GetDivisionApi();
    }, []);
    return (
        <>
            {props.isFetchingDivisionData || props.isAddingDesignationData ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label><b>Select Division *</b></Form.Label>
                                    <Select
                                        placeholder="Select Division"
                                        onChange={handleChangeDivision}
                                        options={getDivisionList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label><b>Select Department *</b></Form.Label>
                                    <Select
                                        isDisabled={props.isFetchingDepartmentData || divisionId === 0}
                                        placeholder="Select Department"
                                        onChange={handleChangeDepartment}
                                        options={getDepartmentNameList}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label><b>Designation Name *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Designation Name"
                                        onBlur={(e) => setDesignationName(e.target.value)}
                                        disabled={(departmentId === 0)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label><b>Designation Description</b></Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Designation Description"
                                        onMouseLeave={(e) => setDesignationDescription(e.target.value)}
                                        disabled={(departmentId === 0)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(designationName) || (departmentId === 0) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadDesignation}>SAVE </Button>
                            )}
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetDivisionApi: () => dispatch(GetDivisionApi()),
        AddDesignationApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddDesignationApi(data, showSuccessAlert, showErrorAlert)),
        GetDepartmentByDivisionIdApi: (divisionId) => dispatch(GetDepartmentByDivisionIdApi(divisionId)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingDivisionData: state.DivisionReducer.isFetchingDivisionData,
    divisionList: state.DivisionReducer.divisionList,
    isAddingDesignationData: state.DesignationReducer.isAddingDesignationData,
    departmentList: state.DepartmentReducer.departmentList,
    isFetchingDepartmentData: state.DepartmentReducer.isFetchingDepartmentData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDesignation);